import { render, staticRenderFns } from "./H5Delivery.vue?vue&type=template&id=be9f7854&scoped=true"
import script from "./H5Delivery.vue?vue&type=script&lang=js"
export * from "./H5Delivery.vue?vue&type=script&lang=js"
import style0 from "./H5Delivery.vue?vue&type=style&index=0&id=be9f7854&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be9f7854",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JSH_ERP\\JSH_ERP\\mgerpweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('be9f7854')) {
      api.createRecord('be9f7854', component.options)
    } else {
      api.reload('be9f7854', component.options)
    }
    module.hot.accept("./H5Delivery.vue?vue&type=template&id=be9f7854&scoped=true", function () {
      api.rerender('be9f7854', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/plugin/order-receive/h5/H5Delivery.vue"
export default component.exports